/* ============================================================
   MIND KONTROL — Theme JS
   Light behavior: category active state, price-gate reveal
   ============================================================ */

(function() {
  'use strict';

  // --- Category/filter chip active state ---
  document.querySelectorAll('[data-mk-cat-group]').forEach(function (group) {
    var cats = group.querySelectorAll('.mk-cat');
    cats.forEach(function (c) {
      c.addEventListener('click', function (e) {
        // If it's a link, let it navigate. If it's a button, just toggle visual state.
        if (c.tagName !== 'A') {
          cats.forEach(function (x) { x.classList.remove('is-active'); });
          c.classList.add('is-active');
        }
      });
    });
  });

  // --- Price-gate click tracking (fires a Shopify analytics event if available) ---
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-mk-unlock]');
    if (!t) return;
    // Not logged in? Push to dealer apply.
    if (window.MK && window.MK.isB2B === false) {
      // Let the native link navigate; this is just an analytics hook.
      if (window.analytics && typeof window.analytics.track === 'function') {
        window.analytics.track('wholesale_price_unlock_clicked', {
          sku: t.getAttribute('data-mk-unlock')
        });
      }
    }
  });

  // --- Announcement ticker: pause on hover ---
  document.querySelectorAll('.mk-ticker').forEach(function (t) {
    var track = t.querySelector('.mk-ticker__track');
    if (!track) return;
    t.addEventListener('mouseenter', function () { track.style.animationPlayState = 'paused'; });
    t.addEventListener('mouseleave', function () { track.style.animationPlayState = 'running'; });
  });

})();
